import { type Placement } from 'tippy.js'
import { UiMenuTriggerTheme } from '../UiMenu/types'
import { SelectAllModes, DisplayModes } from './types'

export default {
  maxHeight: 300,
  triggerLabel: '',
  searchPlaceholder: '',
  noResultsText: '',
  loadingText: '',
  selectAllLabel: '',
  selectAllMode: SelectAllModes.All,
  forceShowSelectAll: false,
  allowSingleDeselect: false,
  total: undefined,
  maxWidth: 250,
  reorderAfterSelect: false,
  itemsLabel: '',
  size: 'md',
  excludedOptions: () => [],
  triggerTheme: UiMenuTriggerTheme.Default,
  placement: 'bottom-start' as Placement,
  display: DisplayModes.List,
}
